import z from "zod";
import { options } from "../constants.schema";

const validate_url = z
  .string()
  .optional()
  .refine((val) => !val || /^https?:\/\/.+$/.test(val), {
    message: "Must be a valid URL",
  });

export const companyInformationSchema = z.object({
  legal_status: z.object(options).optional(),
  legal_name: z.string().optional(),
  commercial_name: z.string().nonempty("The commercial name is required."),
  size_company: z.object(options).optional(),
  location_country: z.object(options).refine((val) => val.id !== "", {
    message: "The HQ country is required.",
  }),
  location_state: z.object(options).optional(),
  industry: z.object(options).optional(),
  company_type: z.object(options).optional(),
  linkedin_url: validate_url,
  website_url: validate_url,
  cover_letter: z.string().optional(),
  picture_profile: z
    .union([z.instanceof(File), z.string(), z.null()])
    .optional(),
  tax_id: z.string().optional(),
  tax_id_file: z.union([z.instanceof(File), z.string(), z.null()]).optional(),
  location_country_emission: z.object(options).optional(),
});

export type CompanyInformationType = z.infer<typeof companyInformationSchema>;

type Kyb = {
  legal_name?: string;
  tax_id_picture_url?: string;
  comments: string;
  created_at?: Date;
  country_emission?: {
    id: string;
    name: string;
  };
  rejection_type?: {
    id: string;
    name: string;
  };
};
export type CompanyInformationResponseType = CompanyInformationType & {
  picture_profile?: string;
  kyb?: Kyb;
};
